import React, { FC, Fragment } from 'react';
import { Paper, Table, TableBody } from '@material-ui/core';

import {
  UserSegmentFragment,
  ContentEmailSpecFragment,
  GetContentEmailSpecsQueryVariables,
} from 'api';
import { Loaders } from 'components';

import ScheduledEmailRow from './ScheduledEmailRow';

interface IProps {
  segments: UserSegmentFragment[];
  scheduledEmails: ContentEmailSpecFragment[];
  variables: GetContentEmailSpecsQueryVariables;
  numActiveUsers: number;
  isExhausted: boolean;
  sentinelRef(node: Element): void;
}

const ScheduledEmails: FC<IProps> = props => {
  const { variables, scheduledEmails, segments, numActiveUsers, isExhausted, sentinelRef } = props;

  return (
    <Fragment>
      <Paper>
        <Table>
          <TableBody>
            {scheduledEmails.map((emailItem, index) => (
              <ScheduledEmailRow
                variables={variables}
                key={index}
                item={emailItem}
                index={index}
                segments={segments}
                numActiveUsers={numActiveUsers}
              />
            ))}
          </TableBody>
        </Table>
      </Paper>
      {!isExhausted && (
        <div ref={sentinelRef}>
          <Loaders.Standard />
        </div>
      )}
    </Fragment>
  );
};

export default ScheduledEmails;
